<template>
    <VLayout align-center pa-0 ma-0>
        <VAutocomplete v-if="!somenteLeitura && !novoProspect"
                       prepend-icon="group"
                       color="primary" label="Cliente"
                       placeholder="Nome, CPF ou telefone"
                       :append-outer-icon="permitirAdicionar && !somenteLeitura ? 'add' : ''"
                       @input="$emit('input', $event)"
                       @click:append-outer="popupCadastroProspect = true"
                       @blur="$emit('blur', $event)"
                       no-filter auto-select-first
                       :search-input.sync="consulta" :items="clientes"
                       item-value="id" item-text="nome" return-object v-model="cliente"
                       :loading="buscando" hide-no-data :disabled="disabled"/>
        <VTextField v-else :value="cliente ? cliente.nome : ''" label="Cliente"
                    prepend-icon="group"
                    disabled/>
        <VTooltip bottom>
            <template v-slot:activator="{ on }">
            <VBtn v-if="permitirEditar" 
                icon
                  small
                  flat
                  :disabled="!cliente || !cliente.id"
                  v-on="on"
                  color="primary"
                  @click="abrirUrlLegado(`GAC/Cliente.aspx?ID=${cliente.id}&IDUnidade=${franquia}`, 'cadastro')">
                <VIcon>assignment_ind</VIcon>
            </VBtn>
            </template>
            <span>Cadastro do cliente</span>
        </VTooltip>
        <Prospect v-model="popupCadastroProspect" @update:cliente="escolherProspect"/>
    </VLayout>
</template>

<script>
    import Prospect from "./Dialog/Prospect";
    import ApiService from "../common/api.service";
    import alerts from "../common/alerts";
    import estetica from '@/mixins/estetica';

    export default {
        name: "AutocompleteCliente",
        mixins: [estetica],
        props: {
            value: Object,
            permitirAdicionar: Boolean,
            somenteLeitura: Boolean,
            permitirEditar: Boolean,
            endpoint: {
                type: String,
                default: 'clientes'
            },
            disabled: {
              type: Boolean,
              default: false
            }
        },
        components: {
            Prospect
        },
        data() {
            return {
                cliente: null,
                novoProspect: false,
                buscando: false,
                consulta: null,
                clientes: [],
                popupCadastroProspect: false,
                limitadorRequisicoes: null,
                millisAtrasoEnvio: 500
            }
        },
        computed: {
            franquia: function () {
                return this.$store.state.parametros.franquia.id
            }
        },
        watch: {
            cliente(novoCliente, oldCliente) {
                if (novoCliente && oldCliente && novoCliente.id === oldCliente.id){
                    return;
                }
                this.$emit('input', novoCliente);
                if (!novoCliente || !novoCliente.id) {
                    this.consulta = null;
                    this.novoProspect = false;
                }
            },
            value(cliente){
                this.cliente = cliente;
            },
            async consulta(consulta, oldConsulta) {
                if (!consulta){
                    this.clientes = [];
                    return;
                }
                consulta = consulta.replace("%", "");
                if (consulta &&
                    consulta !== oldConsulta &&
                    consulta.length > 2 &&
                    (!this.cliente || this.cliente.nome !== consulta)) {
                    clearTimeout(this.limitadorRequisicoes);
                    this.limitadorRequisicoes = await setTimeout(async () => {
                        try {
                            this.buscando = true;
                            this.clientes = (await ApiService.get(`${this.endpoint}/${consulta}`)).data;
                        } catch (e) {
                            alerts.exibirErro('Erro ao buscar clientes', e);
                        } finally {
                            this.buscando = false;
                        }
                    }, this.millisAtrasoEnvio);
                }
            }
        },
        methods: {
            escolherProspect(prospect) {
                this.cliente = prospect;
                this.novoProspect = true
            }
        }
    }
</script>

<style scoped>

</style>
